var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEducationIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.725 22.173l-2.478-2.478v-8.502l1.618-.584a.938.938 0 00.001-1.763L16.061 3.484a.938.938 0 00-.638 0L.618 8.846a.938.938 0 00-.006 1.76l5.464 2.024v6.178c0 .192.058.38.168.537.06.086.632.866 2.094 1.602 1.848.93 4.271 1.402 7.203 1.402 2.93 0 5.366-.47 7.24-1.399 1.477-.731 2.067-1.503 2.13-1.589a.937.937 0 00.18-.552V12.69l2.281-.823v7.827l-2.479 2.478a.937.937 0 000 1.326l2.479 2.479v2.08a.938.938 0 001.875 0v-2.08l2.478-2.48a.937.937 0 000-1.325zM15.742 5.363L27.79 9.725 15.546 14.14 3.663 9.737l12.08-4.374zm7.474 13.072c-3.205 2.883-12.728 2.553-15.266.01v-5.12l7.266 2.692c.115.018.224.117.643.002l7.357-2.652v5.068zm5.093 5.829l-1.427-1.428 1.427-1.427 1.428 1.427-1.428 1.428z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/education-industry.31d867d13c4e3e0d3a8e9aa5fef2f37a.svg";
export { SvgEducationIndustry as ReactComponent };